import React from 'react';
import SavedSongs from '../domains/music/components/SavedSongs';

const SavedSongsPage: React.FC = () => {
  return <SavedSongs />;
};

export default SavedSongsPage; 